import React, { useEffect, useState,useRef , useLayoutEffect } from "react";
import "./NoData.css"
const NoData = () => {
    return (
        <div className="no_data_content">No data available</div>
    )
};
export default NoData;
  